import { Position } from 'lib/_types'
import {
  ChatRoomContextSchemaData,
  GroupContextSchemaData,
  LetterContextSchemaData,
  lingerContextSchema,
  LingerContextSchemaData,
  NotificationContextSchemaData,
  positionToScrollContextSchema,
  PostContextSchemaData,
  scrollContextSchema,
  UserContextSchemaData,
} from '../schema'
import { trackEvent } from './helper'

export const scroll = ({ diff }: { diff: Position }) => {
  if (diff.x === 0 && diff.y === 0) return false

  trackEvent({
    event: scrollContextSchema(positionToScrollContextSchema(diff)),
  })
}

export const login = () => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'login',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
}

export const logout = () => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'logout',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
}

type AppEventParams = {
  user?: UserContextSchemaData
  post?: PostContextSchemaData
  group?: GroupContextSchemaData
  notification?: NotificationContextSchemaData
  letter?: LetterContextSchemaData
  chatRoom?: ChatRoomContextSchemaData
}

export const linger = ({
  params,
  ...props
}: AppEventParams & {
  params: LingerContextSchemaData
}) => {
  trackEvent({
    event: lingerContextSchema(params),
    ...props,
  })
}

export const impression = (props: AppEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'impression',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const share = (props: AppEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'share',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}
